module.exports = __webpack_public_path__ + "img/kirgyzstan.ccefa41.webp";